/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { useDisplayStyle } from '../../utils/styles/display'
import { useFontStyle } from '../../utils/styles/font'
import { useSizeStyle } from '../../utils/styles/size'

const TextWithoutOverflow = ({ children, value, truncate, title, ...props }) => {
  value = value || children

  const style = css`
    ${useDisplayStyle(props)}
    ${useFontStyle(props)}
    ${useSizeStyle(props)}
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `

  return (
    <p css={style} className="text" title={title}>
      {value}
    </p>
  )
}

export default TextWithoutOverflow
